"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
function MarketInsightsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="37305" className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[500px] w-full animate-pulse bg-muted/30 border border-border" />)}
      </div>;
  }
  if (error) {
    return <div className="text-muted-foreground">載入專欄失敗。</div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-muted-foreground">目前尚無專欄內容。</div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => {
      const bgImage = post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618354/img/market_insight_placeholder.png";
      const category = post.categories?.[0]?.name || "百科專欄";
      const date = post.date ? new Date(post.date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }) : "";
      return <Link key={post.id} to={post.link || "#"} className="group flex h-full flex-col" data-index={i}>
            <article className="relative flex h-full flex-col overflow-hidden border border-border bg-card transition-all duration-300 hover:shadow-lg hover:border-primary/30 rounded-[var(--radius)]">
              {}
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                {}
                <div className="absolute inset-0 z-10 bg-transparent transition-all duration-500 group-hover:bg-black/5" />
                
                <img src={bgImage} alt={post.title} className="h-full w-full object-cover transition-all duration-700 group-hover:scale-105" />
              </div>

              {}
              <div className="flex flex-1 flex-col p-8">
                <div className="mb-4 flex items-center gap-3 font-sans text-[10px] font-medium uppercase tracking-wider text-primary">
                  <span>{category}</span>
                  {date && <>
                      <span className="h-px w-3 bg-border" />
                      <span>{date}</span>
                    </>}
                </div>

                <h3 className="mb-6 font-default text-2xl font-medium leading-tight text-foreground transition-colors group-hover:text-primary">
                  {post.title}
                </h3>

                <div className="mt-auto flex items-center gap-2 text-sm font-medium font-sans text-primary transition-all group-hover:gap-3 group-hover:opacity-80">
                  Read More
                  <ArrowRight className="h-3.5 w-3.5" />
                </div>
              </div>
            </article>
          </Link>;
    })}
    </div>;
}
export default function MarketInsights() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="百科專欄" className="relative w-full bg-background py-[160px] text-foreground">
      <div className="container mx-auto px-4">
        <div className="mb-16 border-b border-border pb-6">
          <h2 className="font-default text-4xl text-foreground md:text-5xl">
            百科專欄
          </h2>
        </div>

        <PostsProvider wp_query={{
        per_page: 3,
        orderby: "date",
        order: "desc"
      }}>
          <MarketInsightsConsumer />
        </PostsProvider>
      </div>
    </section>;
}